import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export interface IVibhag {
vibhag_id:number,
vibhag_name:string,
seq_no:number,
is_active:boolean
}

interface IVibhagData {
    list?: Array<IVibhag>;
    pageNo: number;
    pageSize: number;
    searchKey?: string;
    totalCount?: number;
    message?: string;
}

const initialState: IVibhagData = {
    pageNo: 1,
    pageSize: 20,
    searchKey: '',
    list: [],
    totalCount: 0,
    message: '',
};

const vibhagSlice = createSlice({
    name: "vibhag",
    initialState,
    reducers: {
        setVibhagList: (state, _action: PayloadAction<IVibhagData>) => {
            state.list = _action.payload.list;
            state.pageNo = _action.payload.pageNo;
            state.pageSize = _action.payload.pageSize;
            state.totalCount = _action.payload.totalCount;
        },
        resetVibhagToInit: (state) => {
            state = initialState;
        },
        setVibhagMessage: (state, _action: PayloadAction<string>) => {
            state.message = _action.payload;
        },
    },
});

export const { setVibhagList, resetVibhagToInit, setVibhagMessage } = vibhagSlice.actions;

export default vibhagSlice.reducer;

